<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/places/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="locatio_name_label detail_label">
            {{ userNameLabel }}
          </div>
          <div class="pronunciation">
            {{ location.pronunciation }}
          </div>
          <div class="location_name detail_top_title">
            {{ location.userName }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="user_id_label detail_label">
            {{ userIdLabel }}
          </div>
          <div class="user_id">
            {{ location.userId }}
          </div>
          <div class="phone_number_label detail_label">
            {{ phoneNumberLabel }}
          </div>
          <div class="phone_number">
            {{ location.phoneNumber }}
          </div>
          <div class="location_address_label detail_label">
            {{ locationAddressLabel }}
          </div>
          <div class="location_address">
            {{ location.locationAddress }}
          </div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ memoLabel }}
          </div>
          <div class="memo">{{ location.memo }}</div>
          <div class="post_list_label detail_label">
            {{ postLabel }}
          </div>
          <div class="post_list disable_scroll_bar">
            <ul>
              <li v-for="post in location.posts" :key="post.postId">
                {{ post.postName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      userIdLabel: '拠点ID',
      userNameLabel: '拠点名',
      phoneNumberLabel: '電話番号',
      locationAddressLabel: '住所',
      memoLabel: '補足情報',
      postLabel: '所属一覧'
    }
  },
  computed: {
    location() {
      return this.$store.state.places.location
    }
  }
}
</script>

<style scoped>
.post_list {
  height: 60%;
  overflow-y: scroll;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.memo {
  min-height: 30px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/places/placeDetail.vue